// Interface

import util from '@/utils/classToObject'
import { IMissionGlobalState } from './state'
import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'

export class MissionGlobalGetter {  
      
  public missionGlobals(state:IMissionGlobalState,getters:any) {
    return state.missionGlobalsId.map(id => state.missionGlobalById[id])
  }

  // BLF037 — scénarios que les vues Smart Planning montrent : enseigne avec Smart Planning et le
  // type (RG-ACC-050). `missionGlobals` reste brut : modèles et sources de plan (RG-ACC-053).
  public smartScenarios(state:IMissionGlobalState,getters:any) {
    return (getters.missionGlobals as Array<AloDbMissionGlobal>).filter(mig => getters.isMissionGlobalAllowed(mig))
  }

  // BLF037 — onglets des seuls scénarios autorisés pour leur enseigne.
  public allowedDetailSimulations(state:IMissionGlobalState,getters:any) {
    return state.detailSimulations.filter(id => getters.isMissionGlobalAllowed(state.missionGlobalById[id]))
  }

  public detailSimulations(state:IMissionGlobalState,getters:any) {
    return state.detailSimulations
  }
  
  public modifiedAdmMissionGlobal(state:IMissionGlobalState,getters:any) {
    return (state.currentMissionGlobalId?state.modifideMissionGlobalById[state.currentMissionGlobalId]:state.newModifiedAdmMissionGlobal ) as AloDbMissionGlobal
  }

  public originalAdmMissionGlobal(state:IMissionGlobalState,getters:any) {
    return (state.currentMissionGlobalId?getters.missionGlobalsById[state.currentMissionGlobalId]:new AloDbMissionGlobal()) as AloDbMissionGlobal
  }

  public missionGlobalLoading(state:IMissionGlobalState,getters:any) {
    return state.missionGlobalLoading
  }

  public missionGlobalsById(state:IMissionGlobalState) {     
    return state.missionGlobalById
  }

  public missionGlobalStatus(state:IMissionGlobalState) {     
    return state.status
  }

  public adminMissionGlobalFilter(state:IMissionGlobalState) {     
    return state.adminFilter
  }
}

export default util.classToObject(MissionGlobalGetter)